import type * as monaco from "monaco-editor";
import type { MutableRefObject } from "react";

/**
 * Clears the parent's ref to the diff editor only.
 *
 * Do **not** call `IStandaloneDiffEditor.dispose()` here: the instance is owned by
 * `@monaco-editor/react` / `DiffCodeEditor`. Disposing from the parent while the
 * child is still mounted causes Monaco to cancel in-flight diff work and throw
 * uncaught `Canceled` errors; the child disposes the widget on unmount.
 */
export function disposeStandaloneDiffEditor(
  ref: MutableRefObject<monaco.editor.IStandaloneDiffEditor | null>,
): void {
  ref.current = null;
}
